import { render, staticRenderFns } from "./_FOCField.vue?vue&type=template&id=0f497738"
import script from "./_FOCField.vue?vue&type=script&lang=js"
export * from "./_FOCField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports